import { createContext, useContext } from "react";


export const initGameScoreState = {
    default: {
        "total_trophies": 0,
        "total_points": 0,
        "battles": [],
        "musics": []
    }
};

export const GameScore = createContext({
    gameState: initGameScoreState
});

export function useGameScore() {
    return useContext(GameScore);
};